<template>
	<div class="autoqp-main-container">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>

		<div>
			<template v-if="sectionDetails.length != 0 && !LoaderStatus">
				<div class="headtext d-flex align-items-center">
					<div style="width: 35%" class="d-flex" v-if="!viewQuestionBank">
						<img
							src="../../assets/icons/Reports/bckarrow.svg"
							alt=""
							class="pointer"
							@click="goTobackpage()"
						/>
						<div style="padding-left: 16px" class="w-100">
							<div
								class="heading w-75"
								v-if="testDetails.name.length > 69"
								v-b-popover.hover.top="testDetails.name"
							>
								<div class="ellipsis">
									{{ testDetails.name }}
								</div>
							</div>
							<div class="heading w-75" v-else>
								<div class="ellipsis">
									{{ testDetails.name }}
								</div>
							</div>
						</div>
					</div>

					<div style="width: 55%" v-if="shareStatus && !viewQuestionBank">
						<div class="warning-box p-1 d-inline-block">
							<span
								><img src="../../assets/icons/Qpbuilder/warning.svg" alt=""
							/></span>
							<span>
								This test has already been tagged and shared. Any changes made
								will be reflected in the shared test as well.
							</span>
						</div>
					</div>
					<div v-else style="width: 55%"></div>

					<div
						style="width: 10%"
						class="d-flex justify-content-end mr-2"
						@click="goToShare()"
						v-if="
							!viewQuestionBank &&
								(roles.includes('GET_AUTO_INDIVIDUAL') ||
									roles.includes('GET_AUTO_GROUP'))
						"
					>
						<b-button
							class="addbtn"
							:disabled="no_questions"
							v-b-tooltip.hover
							:title="
								no_questions ? 'To Enable Add Questions To All Sections' : ''
							"
						>
							Share
						</b-button>
					</div>
				</div>
				<div
					class="d-flex align-items-center pr-2"
					:class="
						viewQuestionBank ? 'view-sec-main-container' : 'sec-main-container'
					"
				>
					<div
						class="autoqp-mainsec mt-3"
						v-if="!viewQuestionBank"
						:class="!roles.includes('GET_QUESTION_BANK') ? 'width100' : ''"
					>
						<div class="sec-leftside">
							<div class="secsub-leftside">
								<div class="align-items-center pl-3 pr-3">
									<b-row>
										<b-col cols="6">
											<div class="relativeclass">
												<div
													class="relativeclass mt-3 pointer"
													@click="
														(sectionmodal = !sectionmodal),
															(showquesoptions = false)
													"
													ref="sectionparent"
												>
													<div class="fieldsetStyle section-text">
														Select a Section
													</div>
													<div
														class="section-content d-flex justify-content-between align-items-center"
													>
														<div
															class="sectionname"
															v-if="sectionsvalue.name.length > 24"
															v-b-popover.hover.top="sectionsvalue.name"
														>
															{{ sectionsvalue.name | testNameFilter }}
														</div>
														<div class="sectionname" v-else>
															{{ sectionsvalue.name }}
														</div>
														<div>
															<img
																v-if="sectionmodal"
																src="../../assets/uparrow.svg"
																alt=""
															/>
															<img
																v-else
																src="../../assets/downarrow.svg"
																alt=""
															/>
														</div>
													</div>
												</div>
												<div
													ref="sectionselect"
													v-closable="{
														exclude: ['sectionparent', 'sectionselect'],
														handler: 'hidesectionmodal',
													}"
													v-if="sectionmodal"
													class="section-modal"
												>
													<div class="sec-modal-headtext">Select a Section</div>

													<div>
														<div
															class="sec-selectdropdown d-flex sec-mcq-datacard auto-qp-builder-section"
														>
															<b-form-select
																v-model="sectionsvalue"
																@change="selectSection(sectionsvalue)"
																:select-size="sectionDetails.length < 3 ? 2 : 5"
																class="select pointer p-0 sec-mcq-datacard"
															>
																<option
																	class="relativeclass secdropdowncolor text-truncate"
																	:class="
																		selectedSection.sectionID ==
																		carrier.sectionID
																			? 'selected-section'
																			: ''
																	"
																	:value="{
																		name: carrier.name,
																		sectionID: carrier.sectionID,
																		testID: carrier.testID,
																		numbeOfQuestions: carrier.numbeOfQuestions,
																		secMarks: carrier.secMarks,
																	}"
																	:key="carrier.sectionID"
																	v-for="carrier in sectionDetails"
																>
																	<div class="w-100">
																		{{ carrier.name }}
																	</div>
																</option>
															</b-form-select>
														</div>
													</div>
													<div
														class="secmodaltwobtns d-flex pointer justify-content-end"
													>
														<div
															v-if="roles.includes('PUSH_AUTO_SECTION')"
															class="d-flex"
															v-b-modal.sectionNameModal
															@click="$v.$reset()"
														>
															<img
																src="../../assets/secplusicon.svg"
																alt=""
																class="mr-2"
															/>
															<div class="sec-addquestext mr-3">
																Add Section
															</div>
														</div>
														<div
															class="sec-canceltext"
															@click="sectionmodal = !sectionmodal"
														>
															Cancel
														</div>
													</div>
												</div>
											</div>
										</b-col>
										<b-col cols="3">
											<div
												class="autoqp-markcontainer d-flex align-items-center justify-content-between mt-3"
											>
												<div class="d-flex flex-column align-items-center">
													<div class="lightgreentext">
														{{ allquestioncount }}
													</div>
													<div class="qp-right-topbar-text">Questions</div>
												</div>

												<div class="d-flex flex-column align-items-center">
													<div class="pinknumbertext">
														{{ totalmarkscount }}
													</div>
													<div class="qp-right-topbar-text">Marks</div>
												</div>
											</div>
										</b-col>
										<b-col cols="1"></b-col>
										<b-col class="" cols="2">
											<div
												class="d-flex pointer justify-content-end align-items-center mt-4"
											>
												<div
													v-if="roles.includes('PUT_AUTO_SECTION')"
													class="sec-addcheckboxtext mr-3 d-flex align-items-center"
													@click="(editModal = !editModal), copySectionData()"
												>
													<span
														><img
															src="../../assets/icons/Qpbuilder/edit.svg"
															alt=""
													/></span>
													<span class="ml-2">Edit</span>
												</div>
												<div
													v-if="roles.includes('DELETE_AUTO_SECTION')"
													class="sec-addcheckboxtext mr-3 d-flex align-items-center"
													@click="deleteModal = !deleteModal"
												>
													<span
														><img
															src="../../assets/icons/Qpbuilder/delete.svg"
															alt=""
													/></span>
													<span class="">Delete</span>
												</div>
											</div>
										</b-col>
									</b-row>
								</div>

								<hr />
								<div class="d-flex justify-content-between mt-3">
									<div class="d-flex">
										<div class="relativeclass ml-3">
											<div class="secbox-head">MCQ</div>
											<div class="bluenumbertext sec-quesbox">
												{{ mcqQuestionCount }}
											</div>
										</div>
										<div class="relativeclass ml-3">
											<div class="secbox-head">MTF</div>
											<div class="yellownumbertext sec-quesbox">
												{{ mafoQuestionCount }}
											</div>
										</div>
										<div class="relativeclass ml-3">
											<div class="secbox-head">Descriptive</div>
											<div class="yellownumbertext sec-quesbox">
												{{ longQuestionCount }}
											</div>
										</div>
									</div>
									<div>
										<div
											v-if="roles.includes('PUSH_AUTO_QUESTION')"
											class="d-flex relativeclass align-items-center justify-content-end mr-3 pointer"
										>
											<img
												ref="showquesoptions3"
												@click="
													(showquesoptions = !showquesoptions),
														(sectionmodal = false)
												"
												src="../../assets/secplusicon.svg"
												alt=""
											/>
											<div
												ref="showquesoptions1"
												@click="
													(showquesoptions = !showquesoptions),
														(sectionmodal = false)
												"
												class="sec-addquestext ml-2"
											>
												Add Question
											</div>
											<div
												ref="showquesoptions2"
												@click="showquesoptions = !showquesoptions"
												class="ml-2"
											>
												<img
													v-if="!showquesoptions"
													src="../../assets/assess-main-downArrow.svg"
													alt=""
												/>
												<img
													v-else
													src="../../assets/assess-main-upArrow.svg"
													alt=""
												/>
											</div>
											<div
												v-if="showquesoptions"
												class="sec-dropdown"
												v-closable="{
													exclude: [
														'showquesoptions',
														'showquesoptions1',
														'showquesoptions2',
														'showquesoptions3',
													],
													handler: 'hideshowoptions',
												}"
											>
												<div
													v-for="ques in questiontype_options"
													:key="ques"
													class="qp-odd-even"
												>
													<div
														class="p-2"
														@click="selectTypeQuestion(ques.value)"
														:class="
															addquestion == ques.value
																? 'selected-section p-2'
																: ''
														"
													>
														{{ ques.text }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<template v-if="showadd">
								<div class="secsub-second-leftside" id="addcontainer">
									<div
										class="secleftquescard"
										v-for="(item, index) in questionData"
										:key="item['questionKey']"
									>
										<template v-if="item['questionKey'].slice(0, 4) == 'MCQU'">
											<Automcqcard
												:data="item"
												:showindex="index + 1"
												v-on:auto-question-added="getQuestions"
												:autosectionID="selectedSection.sectionID"
												v-on:get-auto-sections="getAllSections(true)"
											/>
										</template>
										<template v-if="item['questionKey'].slice(0, 4) == 'MAFO'">
											<Automatchcard
												:data="item"
												:showindex="index + 1"
												v-on:auto-question-added="getQuestions"
												:autosectionID="selectedSection.sectionID"
												v-on:get-auto-sections="getAllSections(true)"
											/>
										</template>
										<template v-if="item['questionKey'].slice(0, 4) == 'LONG'">
											<Autolongcard
												:data="item"
												:showindex="index + 1"
												v-on:auto-question-added="getQuestions"
												:autosectionID="selectedSection.sectionID"
												v-on:get-auto-sections="getAllSections(true)"
											/>
										</template>
									</div>
									<div
										id="add-question"
										v-if="roles.includes('PUSH_AUTO_QUESTION')"
									>
										<template v-if="addquestion == 'MCQ'">
											<MCQ
												:type="'automcq'"
												v-on:question-added="getAllSections(true)"
												:questions="mcqQuestion"
												@clearData="clearData('MCQ')"
												:autosectionID="selectedSection.sectionID"
												ref="mcqForm"
											/>
										</template>

										<template v-if="addquestion == 'MTF'">
											<MatchtheFollowing
												:type="'automtf'"
												v-on:question-added="getAllSections(true)"
												:questions="mtfQuestion"
												@clearData="clearData('MTF')"
												:autosectionID="selectedSection.sectionID"
												ref="mtfForm"
											/>
										</template>
										<template v-if="addquestion == 'Descriptive'">
											<LongForm
												:type="'autolong'"
												v-on:question-added="getAllSections(true)"
												:questions="descriptiveQuestion"
												@clearData="clearData('Descriptive')"
												:autosectionID="selectedSection.sectionID"
												ref="longForm"
											/>
										</template>
									</div>
								</div>
							</template>
						</div>
					</div>

					<template v-if="showadd && roles.includes('GET_QUESTION_BANK')">
						<div
							:class="
								!viewQuestionBank
									? 'ml-2 mt-3 sec-rightside'
									: 'sec-full-container'
							"
						>
							<b-overlay
								id="overlay-background"
								:show="showOverlay"
								variant="white"
								:opacity="overlayOpacity"
								:blur="overlayBlur"
								rounded="sm"
							>
								<Databank
									:role="'PUSH_AUTO_QUESTION'"
									:autosectionID="selectedSection.sectionID"
									:movestatus="moveStatus"
									:addMulti="addMulti"
									:autoType="$route.query.type"
									:autoSort="$route.query.sort"
									:viewQuestionBank="viewQuestionBank"
									v-on:delete-question-db="deletequestions"
									v-on:changeViewQuestionBank="changeViewQuestionBank"
									v-on:changeViewDataBank="changeViewDataBank"
									v-on:question-added="getAllSections(true)"
								/>
							</b-overlay>
						</div>
					</template>
				</div>
			</template>
		</div>

		<!-----------------  Add Popup starts -------->
		<b-modal
			id="sectionNameModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="modalheading">Add Section</div>
			<div @click="closesecmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>

			<div class="topDiv mt-3 relativeclass">
				<label class="fieldsetStyle"
					>Section Name &nbsp;<span class="asterik">*</span></label
				>
				<b-form-input
					:class="{ error: $v.section.name.$error }"
					v-on:keyup.enter="addsection()"
					class="inputField"
					id="input-1"
					type="text"
					autofocus
					placeholder="Enter here"
					v-model.trim="$v.section.name.$model"
				></b-form-input>
				<div
					style="position: absolute; top: 5px; right: 12px"
					v-if="$v.section.name.$dirty && !$v.section.name.required"
					v-b-popover.hover.top.v-danger="{ content: 'Required' }"
					variant="primary"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
				<div
					style="position: absolute; top: 5px; right: 12px"
					v-if="!$v.section.name.maxLength && $v.section.name.required"
					v-b-popover.hover.top.v-danger="{
						content: 'Should not exceed 128 characters',
					}"
					variant="primary"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
				<div
					style="
            position: absolute;
            top: 5px;
            right: 12px;
            background: var(--bg-white);
          "
					v-if="!$v.section.name.alpha && $v.section.name.required"
					v-b-popover.hover.top.v-danger="{
						content: 'Please Enter a Valid Section Name',
					}"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
			</div>
			<div class="d-flex justify-content-end mt-3">
				<b-button class="addbtn" @click="addsection()">Save</b-button>
			</div>
		</b-modal>
		<!-----------------  Add Popup ends -------->
		<!-----------------  Edit Popup starts -------->
		<b-modal
			id="edit-section-modal"
			v-model="editModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="modalheading">Edit Section</div>
			<div @click="closeSectionEditmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>

			<div class="topDiv mt-3 relativeclass">
				<label class="fieldsetStyle"
					>Section Name &nbsp;<span class="asterik">*</span></label
				>
				<b-form-input
					v-on:keyup.enter="editsection()"
					autofocus
					class="inputField"
					id="input-1"
					type="text"
					placeholder="Enter here"
					v-model.trim="$v.copySection.name.$model"
					:class="{ error: $v.copySection.name.$error }"
				></b-form-input>
				<div
					style="position: absolute; top: 5px; right: 12px"
					v-if="$v.copySection.name.$dirty && !$v.copySection.name.required"
					v-b-popover.hover.top.v-danger="{ content: 'Required' }"
					variant="primary"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
				<div
					style="position: absolute; top: 5px; right: 12px"
					v-if="!$v.copySection.name.maxLength && $v.copySection.name.required"
					v-b-popover.hover.top.v-danger="{
						content: 'Should not exceed 128 characters',
					}"
					variant="primary"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
				<div
					style="
            position: absolute;
            top: 5px;
            right: 12px;
            background: var(--bg-white);
          "
					v-if="!$v.copySection.name.alpha && $v.copySection.name.required"
					v-b-popover.hover.top.v-danger="{
						content: 'Please Enter a Valid Section Name',
					}"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
			</div>
			<div class="d-flex justify-content-end mt-3">
				<b-button class="addbtn" @click="editsection()">Update</b-button>
			</div>
		</b-modal>
		<!-----------------  Edit Popup ends -------->
		<!-----------------  Delete Popup starts -------->
		<b-modal
			id="delete-section-modal"
			v-model="deleteModal"
			centered
			hide-footer
			hide-header
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution!
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="closedeletemodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div
				class="mt-3 caution-modal-text"
				v-if="selectedSection && !shareStatus"
			>
				<span class="text-break"
					>Are you sure you want to delete "{{ selectedSection.name }}" ?</span
				>
			</div>
			<div
				class="mt-3 caution-modal-text"
				v-if="selectedSection && shareStatus"
			>
				<span class="text-break"
					>The test has already been triggered to the candidate and the changes
					made here will impact the ongoing assessment. Do you still want to
					delete the section "{{ selectedSection.name }}"?
				</span>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex justify-content-end">
				<div class="d-flex align-items-center justify-content-end mt-3 mr-3">
					<b-button class="addbtn" @click="deleteSection()">Delete</b-button>
				</div>
				<div class="d-flex align-items-center justify-content-end mt-3">
					<b-button
						class="addbtn"
						@click="$bvModal.hide('delete-section-modal')"
						>Cancel</b-button
					>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Databank from "../sections/Databank.vue";
import {
	getQuestions,
	putAutoGenerate,
	delAutoGenerate,
	getSection,
	testSharedCheck,
} from "../../utils/apiFunctions.js";
import Automcqcard from "../../components/displayAutoCards/AutoMcqCards.vue";
import Automatchcard from "../../components/displayAutoCards/AutomatchTheFollowing.vue";
import Autolongcard from "../../components/displayAutoCards/Autolongcard.vue";
import MatchtheFollowing from "../../components/forms/MatchTheFollowing.vue";
import MCQ from "../../components/forms/Mcq.vue";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import successToast from "../mixin/toast.js";
import errorToast from "../mixin/toast";
import { mapGetters } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import LongForm from "../../components/forms/LongForm.vue";

export default {
	name: "AutoQPBuilder",
	mixins: [successToast, errorToast],
	components: {
		Databank,

		MatchtheFollowing,
		Automcqcard,
		MCQ,
		Automatchcard,
		Spinner,
		LongForm,
		Autolongcard,
	},
	data() {
		return {
			overlayBlur: "4",
			overlayOpacity: 0.46,
			showOverlay: false,
			addMulti: false,
			moveStatus: false,
			questionData: [],
			topicID: "",
			testDetails: {},
			sectionDetails: [],
			viewQuestionBank: false,
			testname: "",
			addquestion: "MCQ",
			mcq: true,
			match: false,
			no_questions: false,
			sectionmodal: false,
			showquesoptions: false,
			descriptive: false,
			LoaderStatus: false,
			showadd: false,
			deleteModal: false,
			editModal: false,
			shareStatus: false,
			confirmModal: false,
			selectedSection: {
				questions: [],
			},

			mcqQuestion: {},
			mtfQuestion: {},
			descriptiveQuestion: {},

			questions: [],
			questiontype_options: [
				{
					value: "MCQ",
					text: "Multiple Choice Question(MCQ)",
				},

				{
					value: "MTF",
					text: "Match the Followings(MTF)",
				},
				{
					value: "Descriptive",
					text: "Descriptive(DESC)",
				},
			],
			sectionsvalue: {
				name: "",
				sectionID: "",
				testID: "",
				numbeOfQuestions: 0,
				secMarks: 0,
			},
			section: {
				testID: this.$route.params.testID,
				portion: "Section",
				name: "",
				topicID: "",
			},
			//copy section
			copySection: { ...this.selectedSection },
		};
	},

	validations: {
		section: {
			name: {
				required,
				maxLength: maxLength(128),
				alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
			},
		},
		copySection: {
			name: {
				required,
				maxLength: maxLength(128),
				alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
			},
		},
		selectedSectionData: {
			name: {
				required,
				maxLength: maxLength(128),
			},
		},
	},
	created() {
		this.LoaderStatus = true;
		this.testDetails.name = this.$route.params.testName;
		this.testShareCheck();
		this.getAllSections(true);

		this.resetMcqQuestion();
		this.resetMtfQuestion();
		this.resetDescriptiveQuestion();
	},
	watch: {
		getAutoSectionDetails(newValue, oldValue) {
			if (oldValue != newValue) {
				this.sectionDetails = newValue;
			}
		},
	},
	computed: {
		...mapGetters(["roles"]),
		mcqQuestionCount() {
			let questionType = {};
			let mcqQuestionCount = 0;
			for (let i in this.questionData) {
				questionType = this.questionData[i];
				let x = questionType.questionKey.substring(0, 4);
				if (x === "MCQU") {
					mcqQuestionCount++;
				}
			}
			return mcqQuestionCount;
		},
		longQuestionCount() {
			let questionType = {};
			let longQuestionCount = 0;
			for (let i in this.questionData) {
				questionType = this.questionData[i];
				let x = questionType.questionKey.substring(0, 4);
				if (x === "LONG") {
					longQuestionCount++;
				}
			}
			return longQuestionCount;
		},
		mafoQuestionCount() {
			let questionType = {};
			let mafoQuestionCount = 0;
			for (let i in this.questionData) {
				questionType = this.questionData[i];
				let x = questionType.questionKey.substring(0, 4);
				if (x === "MAFO") {
					mafoQuestionCount++;
				}
			}
			return mafoQuestionCount;
		},
		totalmarkscount() {
			let totalmarkscount = 0;
			for (let i in this.questionData) {
				totalmarkscount += parseFloat(this.questionData[i].marks);
			}
			return this.naiveRound(totalmarkscount, 2);
		},
		allquestioncount() {
			let allquestioncount = this.questionData.length;
			return allquestioncount;
		},
	},
	methods: {
		resetFormValidations() {
			this.$nextTick(() => {
				if (this.addquestion == "MCQ") {
					this.$refs.mcqForm.clearData();
				} else if (this.addquestion == "MTF") {
					this.$refs.mtfForm.clearData();
				} else {
					this.$refs.longForm.clearData();
				}
			});
		},
		resetMcqQuestion() {
			this.mcqQuestion = {
				autoCorrection: false,
				required: false,
				addToPublic: false,
				addToDatabank: false,
				isFailed: false,
				marks: null,
				questionType: "MCQU",
				topic: "",
				questionMedia: "",
				difficultyLevel: "",
				question: "",
				file: null,
				questionTags: [],
				options: [
					{
						value: "",
						media: "",
						check: false,
					},
					{
						value: "",
						media: "",
						check: false,
					},
				],
			};
		},
		resetMtfQuestion() {
			this.mtfQuestion = {
				autoCorrection: false,
				required: false,
				addToPublic: false,
				addToDatabank: false,
				isFailed: false,
				marks: null,
				questionType: "MAFO",
				topic: "",
				difficultyLevel: "",
				question: "",
				questionMedia: "",
				file: null,
				questionTags: [],
				answerKey: [
					{
						sideA: "",
						sideB: "",
					},
					{
						sideA: "",
						sideB: "",
					},
					{
						sideA: "",
						sideB: "",
					},
				],
			};
		},
		resetDescriptiveQuestion() {
			this.descriptiveQuestion = {
				autoCorrection: false,
				autolong: false,
				required: false,
				addToPublic: false,
				addToDatabank: false,
				isFailed: false,
				marks: null,
				questionType: "LONG",
				sizelimit: 0,
				topic: "",
				difficultyLevel: "",
				question: "",
				answerKey: "",
				correctAnswer: "",
				questionMedia: "",
				file: null,
				questionTags: [],
			};
		},
		clearData(type) {
			if (type == "MCQ") {
				this.resetMcqQuestion();
			} else if (type == "MTF") {
				this.resetMtfQuestion();
			} else {
				this.resetDescriptiveQuestion();
			}
		},
		hideshowoptions() {
			this.showquesoptions = false;
		},
		hidesectionmodal() {
			this.sectionmodal = false;
		},

		async getQuestions() {
			this.LoaderStatus = true;
			let payload = {
				testID: this.$route.params.testID,
				sectionID: this.selectedSection.sectionID,
			};

			const res = await getQuestions(payload);
			if (res.status == 200) {
				this.questionData = res.data.data.questionsBody;
				this.$forceUpdate();
				this.LoaderStatus = false;
			} else {
				this.LoaderStatus = false;
			}
		},

		changeViewQuestionBank() {
			this.viewQuestionBank = !this.viewQuestionBank;
		},

		changeViewDataBank() {
			this.viewQuestionBank = false;
			if (this.showadd) setTimeout(() => this.scrollToBottom());
		},

		naiveRound(num, decimalPlaces = 0) {
			let p = Math.pow(10, decimalPlaces);
			return Math.round(num * p) / p;
		},

		// CHECKS FOR EMPTY SECTION
		// USE no_question VARIABLE FOR ANY VALIDATION BASED ON EMPTY SECTION
		goTobackpage() {
			this.$router.push({
				path: "/autogenerate",
				query: {
					type: this.$route.query.type,
					sort: this.$route.query.sort,
				},
			});
		},
		checkEmptySection() {
			for (const section of this.sectionDetails) {
				if (section.questions.length === 0) {
					this.no_questions = true;
					return;
				}
			}
			this.no_questions = false;
		},

		deletequestions() {
			this.showOverlay = true;
		},

		goToAutoSections() {
			this.$store.commit("autotestVUEX/saveAutoGenData", {
				testName: this.$route.params.testName,
				noofSections: null,
				autoQuestions: null,
				questiontype_options: [],
				editSecName: false,
				autoCheck: false,
				sections: [
					{
						name: "",
						typedistributeRandomly: false,
						cardClose: false,

						addTypeDisable: false,
						typeDifficultyLevel: [],
						noOfQuestions: null,
						alldiffoptions: [],
						longdiffoptions: [],
						mcqdiffoptions: [],
						mtfdiffoptions: [],
						types: [],
						sameDifficultyLevel: false,
						typediffrequired: false,
					},
				],
			});
			return this.$router.push({
				name: "AutogenerateSection",
				query: {
					available: this.$route.query.available,
				},
			});
		},
		//get all sections API

		async getAllSections(flag) {
			try {
				const response = await getSection(this.$route.params.testID);
				if (response.status === 200) {
					if (response.data.data.sectionIDs.length == 0) {
						this.goToAutoSections();
					}
					this.processSectionDetails(response.data.data.sectionIDs, flag);
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		processSectionDetails(sectionDetails, flag) {
			this.sectionDetails = sectionDetails;
			this.LoaderStatus = false;

			if (flag) {
				this.handleFlagCase();
			}

			this.updateQuestionDetails();
		},

		handleFlagCase() {
			let index = this.sectionDetails.findIndex(
				(i) => i.sectionID === this.selectedSection.sectionID
			);

			if (index > -1) {
				this.selectSection(this.sectionDetails[index]);
			} else {
				this.selectSection(this.sectionDetails[0]);
				this.sectionsvalue.name = this.sectionDetails[0].name;
			}

			this.checkEmptySection();
		},

		updateQuestionDetails() {
			for (let i in this.sectionDetails) {
				for (let j in this.sectionDetails[i].questions) {
					this.updateQuestionConfig(this.sectionDetails[i].questions[j]);
				}
			}
		},

		updateQuestionConfig(question) {
			for (let k in question.config) {
				if (question.config[k].SectionID === this.selectedSection.sectionID) {
					question.required = question.config[k].required;
					question.autoCorrection = question.config[k].autoCorrection;
				}
			}
		},

		selectSection(sectionvalue) {
			this.resetFormValidations();
			this.selectedSection = sectionvalue;
			this.sectionmodal = false;
			this.showadd = true;
			for (let i in this.sectionDetails) {
				if (this.sectionDetails[i].sectionID == sectionvalue.sectionID) {
					this.selectedSection = this.sectionDetails[i];
					this.$store.commit(
						"autotestVUEX/saveSelectedSection",
						this.selectedSection
					);
					this.getQuestions();
				}
			}
		},

		async testShareCheck() {
			try {
				const res = await testSharedCheck(this.$route.params.testID);
				if (res.status == 200) {
					this.shareStatus = res.data.data.shareStatus;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		copySectionData() {
			this.copySection = { ...this.selectedSection };
		},
		// close section edit modal
		closeSectionEditmodal() {
			this.$bvModal.hide("edit-section-modal");
		},

		closesecmodal() {
			this.$bvModal.hide("sectionNameModal");
		},

		//edit section API

		async editsection() {
			this.$v.copySection.name.$touch();
			if (!this.$v.copySection.name.$invalid) {
				let payload = this.copySection;
				payload.type = "CHANGE_SEC";
				payload.testID = this.$route.params.testID;
				payload.topicID = this.$route.params.topicID;
				try {
					const response = await putAutoGenerate(payload);
					if (response.status == 200) {
						this.sectionsvalue.name = payload.name;
						let index = this.sectionDetails.findIndex(
							(i) => i.sectionID === payload.sectionID
						);
						if (index > -1) {
							this.sectionDetails.splice(index, 1, this.copySection);
						}
						this.selectedSection = this.copySection;
						this.successToast("Section updated successfully!");
					} else if (response.status == 409) {
						this.errorToast("Section name cannot be the same.");
					} else {
						this.errorToast("Something went wrong!");
					}
				} catch (error) {
					this.errorToast("Something went wrong!");
					throw new Error(`Failed! Status:${error.status}`);
				}
				this.closeSectionEditmodal();
			}
		},
		async addsection() {
			this.$v.$touch();
			if (!this.$v.section.name.$invalid) {
				let data = {};
				this.showadd = true;
				data.testID = this.$route.params.testID;
				data.topicID = this.$route.params.topicID;
				data.type = "ADD_SEC";
				data.name = this.section.name;
				data.typedistributeRandomly = "true";
				data.typeDifficultyLevel = "distinct";
				try {
					let response = await putAutoGenerate(data);
					if (response.status == 200) {
						this.sectionmodal = false;
						let data1 = {};
						data1.name = this.section.name;
						data.testID = this.$route.params.testID;
						data1.sectionID = response.data.data.SectionID;
						data1.numberOfQuestions = 0;
						data1.secMarks = 0;
						data1.questions = [];
						this.sectionDetails.push(data1);
						this.sectionsvalue = data1;
						this.selectSection(data1);
						this.successToast("Section created successfully!");
						this.section = {
							testID: this.$route.params.testID,
							portion: "Section",
							name: "",
							topicID: "",
						};
						this.$v.$reset();
						this.checkEmptySection();
						this.$bvModal.hide("sectionNameModal");
					} else {
						this.errorToast(response.data.data.Details);
					}
				} catch (error) {
					this.errorToast("Something went wrong!");
					this.$bvModal.hide("sectionNameModal");
					throw new Error(`Failed! Status:${error.status}`);
				}
			}
		},
		// scroll to bottom of page when we click on add question button
		scrollToBottom() {
			const scrollContainer = document.getElementById("addcontainer");
			const bottomContainer = document.getElementById("add-question");
			scrollContainer.scrollTo({
				top: scrollContainer.scrollHeight - bottomContainer.offsetHeight - 20,
				left: 0,
				behavior: "smooth",
			});
		},

		selectTypeQuestion(data) {
			this.addquestion = data;
			if (data == "MCQ") {
				this.mcq = true;
				this.match = false;
				this.descriptive = false;
			} else if (data == "MTF") {
				this.match = true;
				this.mcq = false;
				this.descriptive = false;
			} else if (data == "Descriptive") {
				this.match = false;
				this.mcq = false;
				this.descriptive = true;
			}
			this.showquesoptions = !this.showquesoptions;
			this.scrollToBottom();
		},
		// delete section API
		async deleteSection() {
			let payload = {};
			payload.sectionID = this.selectedSection.sectionID;
			payload.type = "DEL_SEC";
			payload.testID = this.$route.params.testID;
			try {
				const response = await delAutoGenerate(payload);
				if (response.status == 200) {
					this.successToast("Section deleted successfully!");
					this.getAllSections(true);
					this.sectionDetails = this.sectionDetails.filter(
						(data) => data.sectionID != payload.sectionID
					);
					if (this.sectionDetails.length > 0) {
						this.selectSection(
							this.sectionDetails[this.sectionDetails.length - 1]
						);
						this.sectionsvalue.name = this.sectionDetails[
							this.sectionDetails.length - 1
						].name;
						this.sectionsvalue.sectionID = this.sectionDetails[0].sectionID;
					} else {
						this.showadd = false;
					}

					this.checkEmptySection();
				} else {
					this.errorToast("Something went wrong!");
				}
			} catch (error) {
				this.errorToast("Something went wrong!");
				throw new Error(`Failed! Status:${error.status}`);
			}
			this.closedeletemodal();
			this.showadd = true;
		},
		closedeletemodal() {
			this.$bvModal.hide("delete-section-modal");
		},
		goToShare() {
			this.$router.push({
				name: "ShareWithPeopleAutoQPBuilder",
				params: {
					topicID: this.$route.params.topicID,
					testID: this.$route.params.testID,
					testName: this.$route.params.testName,
				},
				query: {
					type: this.$route.query.type,
					sort: this.$route.query.sort,
					status: this.$route.query.status,
					autoqp: "inside",
				},
			});
		},
	},
};
</script>

<style>
.width100 {
	width: 100% !important;
}
.autoqp-main-container {
	position: relative;
	top: 64px;
	height: calc(100vh - 100px);
	padding-left: 80px;
	margin: 20px 0px;
}

.sec-leftside {
	width: 100%;
	height: calc(100vh - 150px);
	background: var(--bg-white);
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 8px 8px 0px 0px;
}
.secsub-leftside {
	height: 150px;
	background: var(--bg-white);
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 8px 8px 0px 0px;
}

.qp-odd-even:nth-child(odd) {
	background: #f4f4f4;
}

.qp-odd-even:nth-child(even) {
	background: #fdfdfd;
}
.section-modal {
	margin: 2px;
}

.autoqp-mainsec {
	width: 60%;
}
.view-over-page {
	height: calc(100vh - 305px);
	overflow-y: auto;
	overflow-x: hidden;
}

.view-sec-main-container {
	height: calc(100vh - 84px);
}

.sec-full-container {
	width: 100%;
}

.sel-ques-container {
	height: calc(100vh - 150px);
	position: relative;
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.view-sel-ques-container {
	height: calc(100vh - 105px);
	position: relative;
	background: #ffffff;
	box-shadow: -5px 9px 25px rgb(0 0 0 / 15%);
	border-radius: 5px;
}

.sort-applied {
	width: 10px;
	border-radius: 10px;
	background: #ff7e47;
	height: 9px;
}

.page-alignment {
	position: absolute;
	bottom: 0px;
	width: 100%;
	background: #f2f4fd;
	box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
}

.sort-radio-color .custom-control:nth-child(2n-1) {
	background: #fdfdfd;
	width: 100%;
}
.sec-selectdropdown .custom-select[multiple],
.custom-select[size]:not([size="1"]) {
	min-height: 0%;

	width: 100%;
}
</style>
